import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:80/api'

export const getSubProjectInstallmentReport = (subProjectVersionId) => {
  // http://localhost/api/subproject/subproject-progress-report/document/04F73A6C-DFC1-4C1B-A3AF-E711FAFEAC78
  const url = `${API_ROOT}/subproject/subproject-progress-report/document/${subProjectVersionId}`
  return doGet(url)
}
